import { ApolloError, gql, useQuery } from '@apollo/client';

import { MaDeal } from '@/types/GraphqlSchema';

const MA_DEAL_QUERY = gql`
  query maDeal($id: ID!) {
    maDeal(id: $id) {
      id
      dealType
      comment
      effectiveDate
      considerationMmusd

      maDealDetails {
        id
        dealStatus
        announcementDate
        closingDate
        buySideAdvisor
        sellSideAdvisor
        sellerMotivation
        paymentType
        acreage
        reportedConsiderationComment
        reportedConsiderationBaseCashMmusd
        reportedConsiderationBaseEquityMmusd
        reportedConsiderationContingentMmusd
        reportedDebtMmusd
        reportedCostCarryMmusd
        reportedConsiderationTotalMmusd
        reportedSignatureBonusMmusd
        reportedCostCommitmentMmusd
        reportedTransacted1pReservesMmboe
        reportedTransacted1pOilCondensateReservesMmbbl
        reportedTransacted1pGasReservesBcf
        reportedTransacted2pReservesMmboe
        reportedTransacted2pOilCondensateReservesMmbbl
        reportedTransacted2pGasReservesBcf
        reportedTransacted2cResourceMmboe
        reportedTransacted2cOilCondensateResourceMmbbl
        reportedTransacted2cGasResourceBcf
        reportedProductionBoed
        reportedOilCondensateProductionBbld
        reportedGasProductionMmcfd
        reportedReservesAcquisitionCostUsdPerBoe
        reportedAcreageAcquisitionCostUsdPerAcre
        reportedPricePerFlowingBarrelUsdPerBoed
        reportedCurrentEmissionsIntensityKgco2ePerBoe
        reportedRemainingEmissionsIntensityKgco2ePerBoe
      }

      maCompanyTransactions {
        id
        buyerCompanyName
        sellerCompanyName

        maAssetTransactions {
          id
          assetName

          country {
            name
          }
        }
      }
    }
  }
`;

type UseGetDealResult = {
  deal: MaDeal | null;
  loading: boolean;
  error: ApolloError | undefined;
};

export const useGetDeal: (id: number) => UseGetDealResult = (id: number) => {
  const { data, loading, error } = useQuery(MA_DEAL_QUERY, { variables: { id }, skip: !id });

  return {
    deal: data?.maDeal || null,
    loading,
    error,
  };
};
